export enum LotStatus {
    AWAITING = "AWAITING",
    STARTED = "STARTED",
    COMPLETED = "COMPLETED",
}